import React, { useEffect, useState } from "react";
import { Upload, message } from "antd";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import "./ProfilePictureUpload.css";
import { compressImage } from "../Helpers/Utilities/imageCompression";

function ProfilePictureUpload(props) {
  const [avatarBase64, setAvatarBase64] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = async (info) => {
    setAvatarBase64("");
    setLoading(true);
    
    try {
      // Compress the image to max 500KB
      const originalSizeKB = (info.file.size / 1024).toFixed(2);
      const compressedFile = await compressImage(info.file, 500, 0.8);
      const compressedSizeKB = (compressedFile.size / 1024).toFixed(2);
      
      console.log(`📸 Image Compression Result:`);
      console.log(`   Original size: ${originalSizeKB} KB`);
      console.log(`   Compressed size: ${compressedSizeKB} KB`);
      console.log(`   Reduction: ${(100 - (compressedFile.size / info.file.size * 100)).toFixed(1)}%`);
      
      props.imageFile(compressedFile); // Pass the compressed file
      
      const reader = new FileReader();
      reader.onload = (e) => {
        setAvatarBase64(e.target.result);
        setLoading(false);
      };
      reader.readAsDataURL(compressedFile);
    } catch (error) {
      console.error("Image compression failed:", error);
      message.error("Failed to process image");
      setLoading(false);
    }
  };

  //handle the captured image from camera
  useEffect(() => {
    if (props.capturedImage) {
      setAvatarBase64(props.capturedImage);
    }
  }, [props.capturedImage]);

  // for regular image uploads
  useEffect(() => {
    if (props.imageUrl) {
      setAvatarBase64(props.imageUrl);
    }
  }, [props.imageUrl]);

  const uploadButton = (
    <div className="custom-upload-button" style={{ width: 100, height: 250 }}>
      {loading ? (
        <LoadingOutlined style={{ marginTop: 100 }} />
      ) : (
        <PlusOutlined style={{ marginTop: 100 }} />
      )}
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  return (
    <Upload
      name="avatar"
      listType="picture-card"
      className="avatar-uploader"
      showUploadList={false}
      beforeUpload={() => false}
      onChange={handleChange}
      accept="image/*"
    >
      {avatarBase64 ? (
        <img src={avatarBase64} alt="avatar" style={{ width: "100%" }} />
      ) : (
        uploadButton
      )}
    </Upload>
  );
}

export default ProfilePictureUpload;
